function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 382,
  height: 116,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F8FA",
  fillRule: "evenodd",
  d: "M284.935 3.79c5.241 0 9.491 3.825 9.491 8.544s-4.25 8.544-9.491 8.544h-54.234c5.242 0 9.491 3.826 9.491 8.545s-4.249 8.544-9.491 8.544h29.828c5.242 0 9.491 3.826 9.491 8.545s-4.249 8.544-9.491 8.544h-13.794c-6.609 0-11.966 3.826-11.966 8.545q0 4.719 8.135 8.545c5.241 0 9.49 3.825 9.49 8.544s-4.249 8.545-9.49 8.545H130.369c-5.242 0-9.491-3.826-9.491-8.545s4.249-8.544 9.491-8.544H77.491C72.249 72.146 68 68.32 68 63.6s4.25-8.545 9.49-8.545h54.235c5.241 0 9.49-3.825 9.49-8.544s-4.249-8.545-9.49-8.545H97.829c-5.242 0-9.491-3.825-9.491-8.544s4.249-8.545 9.49-8.545h54.234c-5.241 0-9.491-3.825-9.491-8.544s4.25-8.545 9.491-8.545zm0 34.177c5.241 0 9.491 3.826 9.491 8.545s-4.25 8.544-9.491 8.544c-5.242 0-9.491-3.825-9.491-8.544s4.249-8.545 9.491-8.545",
  clipRule: "evenodd",
  style: {
    fill: "#f7f8fa",
    fill: "color(display-p3 .9702 .9735 .98)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#476CFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.1,
  strokeWidth: 7.5,
  d: "M318.59 21.778h-10.03M326.349 4.54h-21.072zm8.588 0h-2.725zM115.745 107.226h-12.238m5.239-19.488h-25.71zm-34.427 0H68z",
  style: {
    stroke: "#476cff",
    stroke: "color(display-p3 .2784 .4235 1)",
    strokeOpacity: 0.1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#476CFF",
  fillOpacity: 0.24,
  d: "M167 56.602v-36h-6v-6h9a3 3 0 0 1 3 3v36h37.314l6-24H179v-6h41.16a3 3 0 0 1 2.91 3.729l-7.5 30a3.004 3.004 0 0 1-2.91 2.27H170a3 3 0 0 1-3-3m6 21a6.003 6.003 0 0 1-6-6 6 6 0 1 1 6 6m36 0a6.003 6.003 0 0 1-6-6 6 6 0 1 1 6 6",
  style: {
    fill: "#476cff",
    fill: "color(display-p3 .2784 .4235 1)",
    fillOpacity: 0.24
  }
}));
export { SvgCart as ReactComponent };
export default __webpack_public_path__ + "6aa119dec0c1b061e4262b42a4bbe6e8.svg";